<template>
  <a-dialog ref="dialog" name="restart_checks" :loading="loading" size="small" @open="opened" @close="$reset">
    <span slot="title">{{ $t('title-verifications') }}</span>
    <div slot="content">
      {{ $t('restart-verifications') }} <code>{{ ids.length }}</code> {{ $t('keywords-verifications') }}
    </div>
    <span slot="actions">
      <v-btn color="warning" text @click="submit">{{ $t('actions.restart') }} {{ ids.length }} {{ $tc('verifications', ids.length ) }}</v-btn>
    </span>
  </a-dialog>
</template>

<script>
export default {
  name: 'RestartChecksDialog',
  data() {
    return {
      loading: '',
      ids: []
    }
  },
  methods: {
    opened({ids}) {
      if (ids.length === 0) {
        this.$ui.warning(this.$t('ui-warning'))
        if (this.$refs.dialog) this.$refs.dialog.close()
      }

      this.ids = ids
    },
    async submit() {
      this.loading = this.$t('verification-copy')

      try {
        await this.$api.post('checks/restart', {ids: this.ids}, {notifyErrors: false})
        this.$ui.success(this.$t('ui-success'))
        this.$bus.emit('datacenter_check/require_refresh')
        if (this.$refs.dialog) this.$refs.dialog.close()
      } catch (err) {
        if (err.exception === 'ThrottledCreateCheckException') {
          if (this.$account.getSubscription('check-position').name === 'default') {
            this.$bus.emit('notification/payment_required_for_more_monitor_refresh')
          } else {
            this.$bus.emit('notification/account_limitation_for_more_monitor_refresh')
          }
        }
      } finally {
        this.loading = ''
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"keywords-verifications": "keywords ? This operation may take several minutes.",
		"restart-verifications": "Would you like to restart the verification of",
		"title-verifications": "Restart the checks",
		"ui-success": "The data center checks will be restarted in a few seconds.",
		"ui-warning": "You must at least select a check to restart.",
		"verification-copy": "Copy of verifications",
		"verifications": "verification | checks"
	},
	"es": {
		"keywords-verifications": "palabras clave ? Esta operación puede tardar varios minutos.",
		"restart-verifications": "¿Le gustaría volver a ejecutar la verificación de",
		"title-verifications": "Vuelva a ejecutar las verificaciones",
		"ui-success": "Las verificaciones del centro de datos se reiniciarán en unos segundos.",
		"ui-warning": "Debe seleccionar al menos una verificación para que se vuelva a ejecutar.",
		"verification-copy": "Copia de verificaciones",
		"verifications": "verificación | verificaciones"
	},
	"fr": {
		"keywords-verifications": "mot(s) clé(s) ? Cette opération peut prendre plusieurs minutes.",
		"restart-verifications": "Souhaitez-vous relancer la vérification de",
		"title-verifications": "Relancer les vérifications",
		"ui-success": "Les vérifications de datacenter seront relancées dans quelques secondes.",
		"ui-warning": "Vous devez au moins selectionner une vérification à relancer.",
		"verification-copy": "Copie des vérifications",
		"verifications": "vérification | vérifications"
	},
	"it": {
		"keywords-verifications": "parole chiave ? Questa operazione potrebbe richiedere diversi minuti.",
		"restart-verifications": "Desideri riavviare la verifica di",
		"title-verifications": "Riavvia le verifiche",
		"ui-success": "Le verifiche del datacenter verranno riavviate tra pochi secondi.",
		"ui-warning": "Devi selezionare almeno una verifica da riavviare.",
		"verification-copy": "Copia delle verifiche",
		"verifications": "verifica | verifiche"
	},
	"pt": {
		"keywords-verifications": "palavras-chave ? Esta operação pode demorar vários minutos.",
		"restart-verifications": "Gostaria de reiniciar a verificação de",
		"title-verifications": "Reiniciar as verificações",
		"ui-success": "As verificações de datacenter serão reiniciadas em alguns segundos.",
		"ui-warning": "Deve selecionar pelo menos uma verificação para reiniciar.",
		"verification-copy": "Cópia das verificações",
		"verifications": "verificação | verificações"
	},
	"pl": {
		"keywords-verifications": "słów kluczowych ? Ta operacja może potrwać kilka minut.",
		"restart-verifications": "Czy chcesz ponownie uruchomić weryfikację",
		"title-verifications": "Ponownie uruchom sprawdzenia",
		"ui-success": "Sprawdzenia centrum danych zostaną ponownie uruchomione za kilka sekund.",
		"ui-warning": "Musisz wybrać co najmniej jedno sprawdzenie do ponownego uruchomienia.",
		"verification-copy": "Kopiowanie weryfikacji",
		"verifications": "weryfikacja | weryfikacje"
	}
}
</i18n>
